export const APP_LOCALES = ["en", "ru", "ua"] as const;

export type AppLocale = (typeof APP_LOCALES)[number];

export const LANDING_LANGUAGE_COOKIE = "taroterra_lang";
export const APP_LANGUAGE_STORAGE_KEY = "i18nextLng";

export function normalizeAppLocale(value: string | null | undefined): AppLocale {
  const normalized = value?.trim().toLowerCase().split(",")[0]?.split("-")[0];
  if (normalized === "uk" || normalized === "ua") {
    return "ua";
  }
  if (normalized === "ru") {
    return "ru";
  }
  return "en";
}

export function toLandingLocale(value: string | null | undefined): "uk" | "en" | "ru" {
  const locale = normalizeAppLocale(value);
  return locale === "ua" ? "uk" : locale;
}

export function toIntlLocale(value: string | null | undefined): string {
  switch (normalizeAppLocale(value)) {
    case "ru":
      return "ru-RU";
    case "ua":
      return "uk-UA";
    default:
      return "en-US";
  }
}

export function persistAppLanguage(value: string | null | undefined): AppLocale {
  const locale = normalizeAppLocale(value);
  if (typeof window === "undefined") {
    return locale;
  }

  window.localStorage.setItem(APP_LANGUAGE_STORAGE_KEY, locale);
  const cookieParts = [
    `${LANDING_LANGUAGE_COOKIE}=${toLandingLocale(locale)}`,
    "Path=/",
    "Max-Age=31536000",
    "SameSite=Lax",
  ];

  if (
    window.location.hostname === "taroterra.com" ||
    window.location.hostname.endsWith(".taroterra.com")
  ) {
    cookieParts.push("Domain=.taroterra.com");
  }

  if (window.location.protocol === "https:") {
    cookieParts.push("Secure");
  }

  document.cookie = cookieParts.join("; ");
  document.documentElement.lang = toIntlLocale(locale);
  return locale;
}
